import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  useParams,
  useHistory,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import {
  VariableSizeGrid as Grid,
} from "react-window";
import { Box } from "@mui/material";

import { setPlaylist } from "../../actions/set-Playlist";
import { setGroupList } from "../../actions/set-Group";
import { resetMemory } from "../../other/last-opened-mode";
import { loadGroup, loadPlaylist } from "../../other/load-playlist";
import { convertRemToPixels, convertVhToPixels } from "../../other/convert-rem";
import Popup from "../Popup/Popup";
import DB from "../../other/local-db";
import BackgroundPlayer from "./BackgroundPlayer";
import MoreInfo from "./MoreInfo";
import PlayerSeries from "../Series/PlayerSeries";
import RowItem from "./RowItem";
import PlayerVod from "./PlayerVod";
import Movies from "../Movies/Movies";
import { Loading } from "../../other/Player-github/style";


const MainVod = () => {
  const { category, playingMode } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const query = useQuery();
  const searchText = query.get("search");
  const [streamList, setStreamList] = useState([]);
  const [playlist, setPlaylistState] = useState(streamList);
  const [loadedCategory, setLoadedCategory] = useState(-1);
  const [showPopup, setShowPopup] = useState(false);
  const [randomMovie, setRandomMovie] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [refresh, setRefresh] = useState(1);

  const categories = useSelector((state) => state.groupsList);

  useEffect(() => {
    if (!location.pathname.match(/info|fullscreen|menu/)) {
      setRandomMovie({
        ...searchRandomMovie(
          isNaN(category) && category === undefined
            ? playlist
            : playlist.filter((x) => x.category_id === category)
        ),
      });
    }
  }, [category]);

  useEffect(() => {
    if (!searchText) {
      setPlaylistState(streamList);
      setShowPopup(false);
      return;
    }
    const searched = streamList.filter((x) =>
      x.name.toLowerCase().includes(searchText.toLowerCase())
    );
    if (searched.length === 0) {
      setPlaylistState(streamList);
      setShowPopup(true);
    } else {
      setPlaylistState(searched);
    }
  }, [searchText]);

  useEffect(() => {
    const fetchData = async () => {
      let cat = categories;
      const reset = resetMemory(playingMode);
      if (
        reset === false &&
        (location.pathname.match(/info|fullscreen|menu/) ||
          (location.pathname.match(/category/) && category === undefined) ||
          category === loadedCategory)
      ) {
        return;
      }

      setLoadedCategory(category);
      setIsLoading(true);
      setRefresh(0);

      if (reset === true || cat.length === 0) {
        await loadGroup(playingMode).then((gps) => {
          if (!gps || gps.length === 0) {
            history.replace("/");
            return;
          }
          gps.unshift(
            {
              category_id: "fav",
              favorite: 1,
              category_name: "Favorites",
            },
            {
              category_id: "toend",
              history: 1,
              category_name: "History",
            }
          );
          dispatch(setGroupList(gps || []));
          cat = gps;
        });
      }
      await loadPlaylist(playingMode, category || "ALL").then((chs) => {
        if (category && isNaN(category)) {
          chs = chs.filter((s) => {
            const f = DB.findOne(
              playingMode,
              playingMode === "series" ? s.series_id : s.stream_id,
              category === "fav"
            );
            return f && (category === "fav" || (f.tot > 3 && f.tot < 95));
          });
        }
        dispatch(setPlaylist(chs || []));
        setIsLoading(false);
        setStreamList(chs || []);
        setPlaylistState(chs || []);
        setRandomMovie({
          ...searchRandomMovie(
            isNaN(category) && category === undefined
              ? chs
              : chs.filter((x) => x.category_id === category)
          ),
        });
        setRefresh(1);
      });
    };
    fetchData().catch((err) => console.log(err));
  }, [dispatch, category, playingMode, location.pathname]);

  const Cell = ({ columnIndex, rowIndex, style }) => {
    if (rowIndex === 0) {
      if (columnIndex !== 0) return null;
      return randomMovie && randomMovie.name ? (
        [
          <BackgroundPlayer
            key={`bg-${randomMovie.stream_id || randomMovie.series_id}`}
            name={randomMovie.name}
            category_id={randomMovie.category_id}
            stream_id={randomMovie.stream_id || randomMovie.series_id}
            isSeries={playingMode === "series"}
            stream_icon={randomMovie.stream_icon || randomMovie.cover}
            style={style}
            existingTmdb={randomMovie.tmdb}
            selected={randomMovie}
            title={
              category &&
              categories.length > 0 &&
              (isNaN(category)
                ? getOtherCategoryName(category)
                : categories.find(
                    (x) => parseInt(x.category_id) === parseInt(category)
                  ).category_name)
            }
          />,
        ]
      ) : (
        <h3 style={{ color: "white", marginLeft: "1%" }}>
          {category &&
            categories.length > 0 &&
            (isNaN(category)
              ? getOtherCategoryName(category)
              : categories.find(
                  (x) => parseInt(x.category_id) === parseInt(category)
                ).category_name)}
        </h3>
      );
    } else {
      const index = (rowIndex - 1) * 6 + columnIndex;
      console.log(playlist[index]);
      if (!playlist[index]) return null;
      return (
        <RowItem
          id={index}
          key={"vod" + (playlist[index].stream_id || playlist[index].series_id)}
          name={playlist[index].name}
          stream_icon={playlist[index].stream_icon || playlist[index].cover}
          stream_id={playlist[index].stream_id || playlist[index].series_id}
          stream_url={playlist[index].direct_source}
          isSeries={playingMode === "series"}
          container_extension={playlist[index].container_extension}
          category_id={playlist[index].category_id}
          existingTmdb={playlist[index].tmdb}
          last={false}
          style={{
            ...style,
            paddingBottom: ".7rem",
            marginLeft: "1%",
            textDecoration: "none",
          }}
        />
      );
    }
  };

  const getOtherCategoryName = (cat) =>
    cat === "fav" ? "Favorites" : "History";

  return (
    <div>
      <Route path="/:playingMode/">
        {isLoading && (
          <Box
            sx={{
              height: "100vh",
              overflow: "auto",
              maxWidth: "100%",
              width: "100vw",
              overflowX: "hidden",
              backgroundColor: "transparent",
              position: "absolute",
              zIndex: 100000000000000000,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading color={"var(--second-color);"}>
              <div>
                <div />
                <div />
                <div />
              </div>
            </Loading>
          </Box>
        )}
        <Box
          sx={{
            height: "100vh",
            overflow: "auto",
            maxWidth: "100%",
            overflowX: "hidden",
            backgroundColor: "background.default",
            overflowY: "hidden",
          }}
        >
          <Box
            component="ul"
            sx={{
              backgroundColor: "background.default",
              listStyleType: "none",
              paddingLeft: "0rem",
              maxWidth: "100vw",
              overflow: "hidden",
              zIndex: 1,
            }}
          >
            {!category && playingMode === "movie" && <Movies/>}
            {!category && playingMode === "series" && <>series</>}
            {refresh !== 0 && (
              <Grid
                columnCount={6}
                columnWidth={(index) =>
                  index === 0
                    ? convertVhToPixels("16.6vw")
                    : convertVhToPixels("16.6vw")
                }
                height={convertVhToPixels("100vh") - convertRemToPixels(3.5)}
                rowCount={parseInt(Math.ceil(playlist.length / 6)) + 1}
                rowHeight={(index) => {
                  if (index === 0) {
                    if (randomMovie && randomMovie.name)
                      return convertVhToPixels("70vh");
                    else return convertVhToPixels("5vh");
                  } else return convertVhToPixels("15vw") * 1.5;
                }}
                width={convertVhToPixels("100vw")}
                useIsScrolling={true}
                style={{ overflowX: "hidden" }}
              >
                {Cell}
              </Grid>
            )}
          </Box>
        </Box>
        {showPopup && (
          <Popup
            title={`No stream found with '${searchText}'`}
            description={"Search will be reset."}
            icon={"fas fa-search"}
            onclick={() => {
              setShowPopup(false);
              history.replace(location.pathname.split("?")[0]);
            }}
          />
        )}
        <Switch>
          <Route path="/movie/category/:category/:stream_id/play/">
            <PlayerVod />
          </Route>
          <Route path="/series/category/:category/:stream_id/play/season/:season/episode/:episode/">
            <PlayerSeries />
          </Route>
          <Route path="/:playingMode/category/:category/:stream_id/info/">
            <MoreInfo key={"info-" + category} />
          </Route>
        </Switch>
      </Route>
    </div>
  );
};

export default MainVod;

function searchRandomMovie(playlist) {
  playlist = playlist.filter(
    (x) =>
      !x.name.match(
        /xxx|porn|sex|bbc|bitch|cunt|cock|cum|piss|anal|tits|blowjob|masturbate|dick|suck|gangbang/i
      )
  );
  const tempPlaylist = playlist.filter((x) => x.rating >= 7);
  if (tempPlaylist.length > 0) {
    return {
      ...tempPlaylist[Math.floor(Math.random() * tempPlaylist.length)],
    };
  } else
    return {
      ...playlist[Math.floor(Math.random() * playlist.length)],
    };
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
